import { render, staticRenderFns } from "./UsersView.vue?vue&type=template&id=4e4e3d4b&"
import script from "./UsersView.vue?vue&type=script&lang=ts&"
export * from "./UsersView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports